import React from "react";

const DatePickerInput = ({value, onClick}) => (
    <button className="example-custom-input" onClick={onClick}>
      {value}
    </button>
);
export default DatePickerInput;